/** @format */
import recommendationTpl from './recommendation.tpl.html';
import 'angular';
import { studentApplicationModelModule } from '../model/studentApplication.model';
import { publicPersonServiceModule } from '../service/publicPerson.service';

export const recommendationModule = 'sis-components.applications.recommendation';

(function () {
    recommendationController.$inject = ['publicPersonService'];
    /**
     * Use Angular component RecommendationComponent instead in future development.
     *
     * @deprecated
     */
    angular.module(recommendationModule, [studentApplicationModelModule, publicPersonServiceModule]).component('recommendation', {
        template: recommendationTpl,
        controllerAs: '$ctrl',
        controller: recommendationController,
        bindings: {
            formalRecommendation: '<',
            contentRecommendation: '<',
            approvalRequestType: '<',
        },
    });

    function recommendationController(publicPersonService) {
        const $ctrl = this;
        $ctrl.$onInit = function () {
            if ($ctrl.formalRecommendation && $ctrl.formalRecommendation.responsiblePerson) {
                publicPersonService.findById($ctrl.formalRecommendation.responsiblePerson).then(function (person) {
                    $ctrl.formalRecommendationResponsiblePerson = person.fullName;
                });
            }
            if ($ctrl.contentRecommendation && $ctrl.contentRecommendation.responsiblePerson) {
                publicPersonService.findById($ctrl.contentRecommendation.responsiblePerson).then(function (person) {
                    $ctrl.contentRecommendationResponsiblePerson = person.fullName;
                });
            }
        };
    }
})();
